import { createContext } from "react";

export const mobileSidebarContext = createContext();
